import { useCallback, useEffect } from "react";

export const usePlayVideoInView = (
  ref: React.MutableRefObject<HTMLVideoElement | null>,
  isInView: boolean = false,
  shouldResetCurrentTime?: boolean,
) => {
  const playVideo = useCallback(
    async (videoRef: HTMLVideoElement) => {
      try {
        if (shouldResetCurrentTime) {
          videoRef.currentTime = 0;
        }

        await videoRef.play();
      } catch {}
    },
    [shouldResetCurrentTime],
  );

  const pauseVideo = useCallback(async (videoRef: HTMLVideoElement) => {
    try {
      await videoRef?.pause();
    } catch {}
  }, []);

  useEffect(() => {
    const videoEl = ref.current;

    if (!videoEl) {
      return;
    }

    if (isInView) {
      playVideo(videoEl);
    }

    return () => {
      pauseVideo(videoEl);
    };
  }, [ref, isInView, playVideo, pauseVideo]);
};
